// extracted by mini-css-extract-plugin
module.exports = {"notFound":"NotFound_notFound__1LO5m","card":"NotFound_card__klKhB","icon":"NotFound_icon__25U2J"};